import React from 'react';
import { View,  TouchableOpacity, StyleSheet } from 'react-native'; 
import {Text, Styles} from "./../UI-Components";

const deviceWidth = '100%'


export default function({price, subjectName, onPress, hasUserPaid, style, testSeriesName}) {
    return(
        <>
        {
            price && !hasUserPaid ? 
            <View style={[styles.container, {...style}]}>
                <View style={[styles.flexCenter, styles.f1, styles.bgWhite]}>
                    <Text style={styles.subjectName} lineBreakMode="tail" numberOfLines={1}>
                        {subjectName || testSeriesName}
                    </Text>
                    <Text style={styles.price}>₹ {price}</Text>
                </View>
                <View style={[styles.flexCenter, styles.f3, styles.buttonBG]}> 
                    <TouchableOpacity
                        onPress={() => typeof onPress === 'function' ? onPress()  : null}
                        style={[styles.f1, styles.flexCenter, {width: '100%', height: '100%'}]}
                    >
                        <Text style={styles.buyNow}>Buy Now</Text>
                    </TouchableOpacity>
                </View>
            </View>
            : null
        }
        </>
    )
}


const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        width: deviceWidth,
        flexDirection: 'row',
        // paddingBottom: isIphoneX() ? 25 : 0,
        
        // paddingBottom: isIos ? 25 : 0
        // elevation: 8 
    },
    flexCenter: {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        paddingHorizontal: 8,
        paddingVertical: 6
    },
    f1: {
        // flex: 1
        width: '40%'
    },
    f3: {
        // flex: 3
        width: '60%'
    },
    subjectName: {
        color: '#999',
        fontSize: 8
    },
    price: {
        color: '#292929',
        fontSize: 16
    },
    buyNow: {
        color: '#fff',
        fontSize: 16
    },
    buttonBG: {
        backgroundColor: Styles.dangerColor,
        borderTopWidth: 0.5,
        borderTopColor: Styles.dangerColor
    },
    bgWhite: {
        backgroundColor: Styles.white,
        borderTopWidth: 0.5,
        borderTopColor: '#B8C0C9',
        borderBottomColor: '#B8C0C9',
        borderBottomWidth: 0.5
    }
})

